import React from 'react';
import cx from 'classnames';
import RowItem from '../RowItem/RowItem';
import styles from './Row.scss';
import containerStyles from '../RowItem/RowItem.scss';

function Row({
  row,
  isMobileViewport,
  height,
  isTrackingPageFontExisted,
  uploadedTrackingPageFont,
}) {
  const { rowItems } = row;
  const heightClass = `rowItem${height}`;
  const containerHeightClass = `rowItemContainerMobile${height}`;

  return (
    <div className={
      cx(
        styles.row,
        styles[heightClass],
        {
          [containerStyles[containerHeightClass]]: isMobileViewport,
        },
      )
    }
    >
      {rowItems.map((rowItem) => (
        <RowItem
          key={rowItem.id}
          isMobileViewport={isMobileViewport}
          isTrackingPageFontExisted={isTrackingPageFontExisted}
          uploadedTrackingPageFont={uploadedTrackingPageFont}
          rowItem={rowItem}
        />
      ))}
    </div>
  );
}

export default Row;
